import Config from "app-core/config";

export default {
  title: () => Config.getVueApp().$tCaption('Adthos Platform', '@app-info'),
};
